export default __webpack_public_path__ + "static/media/13.84f8e7e7.webp";